import { render, staticRenderFns } from "./regimestributariosEditar.vue?vue&type=template&id=1e9c9f7d&scoped=true&"
import script from "./regimestributariosEditar.vue?vue&type=script&lang=js&"
export * from "./regimestributariosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9c9f7d",
  null
  
)

export default component.exports